import { APIClient } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { EquipmentStateName, EquipmentStateTrigger, IEquipment, UpdateEquipmentState } from '@frontend/equipment/types';

export class EquipmentWorkflowClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async updateEquipmentState(accountId: string, equipmentId: string, equipmentState: UpdateEquipmentState, withCredentials?: Token): Promise<IEquipment> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/change-state`, equipmentState, true, withCredentials);
        return await this.handleResponse<IEquipment>(response);
    }

    public static async postTriggerEquipmentState(accountId: string, equipmentId: string, trigger: EquipmentStateTrigger): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }

    public static async postDetermineFutureEquipmentState(
        accountId: string,
        equipmentId: string,
        trigger: EquipmentStateTrigger
    ): Promise<{ future_state: EquipmentStateName } & IEquipment> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/equipments/${equipmentId}/determine-future-state`, trigger);
        return await this.handleResponse<{ future_state: EquipmentStateName } & IEquipment>(response);
    }
}
